'use client';

import {
  Modal as HeroUiModal,
  ModalBody as HeroUiModalBody,
  ModalContent as HeroUiModalContent,
  ModalFooter as HeroUiModalFooter,
  ModalHeader as HeroUiModalHeader,
  useDisclosure as HeroUiUseDisclosure,
  type ModalContentProps,
  type ModalProps,
} from '@heroui/modal';
import { forwardRef } from 'react';
import { cn } from '@/utils';

export const Modal = forwardRef<HTMLElement, ModalProps>(function Modal(
  { placement = 'top-center', ...props },
  ref,
) {
  return <HeroUiModal ref={ref} placement={placement} {...props} />;
});
export const ModalHeader = HeroUiModalHeader;
export const ModalBody = HeroUiModalBody;
export const ModalFooter = HeroUiModalFooter;

export const ModalContent = ({ className, ...props }: ModalContentProps) => (
  <HeroUiModalContent {...props} className={cn('!rounded-2xl', className)} />
);

export const useDisclosure = HeroUiUseDisclosure;
